<template>
	<div class="ml2 mb2">
		<div
			class="xs-middle lh125 mb2"
			v-if="data.type === 'object' || data.type === 'array'"
		>
			<div
				@click.stop="toggleOpen"
				:class="data.depth === 0 ? 'fs4 c6' : ''"
				class="flex fw7"
				:style="data.depth !== 0 ? this.styles.key : ''"
			>
				<crm-icon
					class="mr2"
					name="up"
					:style="`transform: rotate(${isOpen ? '180' : '90'}deg);`"
					color="c6"
				/>
				{{ data.key }}:
				<span class="fw3 c6">&nbsp;{{ lengthString }}</span>
			</div>
			<js-object-view-item
				v-for="child in data.children"
				:key="getKey(child)"
				v-show="isOpen"
				:data="child"
				:styles="styles"
				:maxDepth="maxDepth"
			/>
		</div>
		<div class="fw7 ml4 p2 pl3 flex" v-else>
			<span :style="this.styles.key">{{ data.key }}:&nbsp;</span>
			<div
				v-if="data.type === 'htmlString'"
				v-html="data.value"
				:style="getValueStyle(data.type)"
			></div>
			<span v-else :style="getValueStyle(data.type)">
				{{ JSON.stringify(data.value) }}
			</span>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
export default {
	name: "JsObjectViewItem",
	props: {
		data: {
			required: true,
			type: Object
		},
		maxDepth: {
			type: Number,
			required: false,
			default: 1
		},
		styles: {
			type: Object,
			required: true
		}
	},
	components: {
		CrmIcon
	},
	data() {
		return {
			isOpen: this.data.depth <= this.maxDepth
		}
	},
	methods: {
		toggleOpen() {
			this.isOpen = !this.isOpen
		},
		getKey(val) {
			if (!isNaN(val.key)) {
				return val.key + ":"
			} else {
				return '"' + val.key + '":'
			}
		},
		getValueStyle(type) {
			return this.styles[type || "value"] || this.styles.string
		}
	},
	computed: {
		lengthString() {
			if (this.data.length === 1 && this.data.depth === 0) return ""
			if (this.data.type === "array") {
				return `${this.data.length} ${
					this.data.length === 1 ? "element" : "elements"
				}`
			}
			return `${this.data.length} ${
				this.data.length === 1 ? "property" : "properties"
			}`
		}
	}
}
</script>

<style></style>
